import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { API_BASE_URL } from "../../config";

const TicketLogs = ({ ticketId, getAuthHeader }) => {
  const [logs, setLogs] = useState([]);
  const [search, setSearch] = useState("");

  const loadLogs = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/tickets/${ticketId}/logs`,
        { headers: getAuthHeader() }
      );
      setLogs(res.data);
    } catch (err) {
      console.error("Log load error:", err);
    }
  };

  useEffect(() => {
    loadLogs();
  }, [ticketId]);

  const filtered = logs.filter((row) =>
    Object.values(row).some((v) =>
      String(v).toLowerCase().includes(search.toLowerCase())
    )
  );

  const columns = [
    { name: "Reported By", selector: (row) => row.reported_by, sortable: true },
    { name: "Priority", selector: (row) => row.priority, sortable: true },
    { name: "Status", selector: (row) => row.status, sortable: true },
    { name: "Resolution", selector: (row) => row.resolution, sortable: true },
    { name: "Assign", selector: (row) => row.assign, sortable: false },
  ];

  return (
    <div className="card p-3">
      <h4>Log Information</h4>

      <div className="row mb-2">
        <div className="col-md-3">
          <input
            type="text"
            placeholder="Search..."
            className="form-control"
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <DataTable
        columns={columns}
        data={filtered}
        pagination
        striped
        highlightOnHover
      />
    </div>
  );
};

export default TicketLogs;
